import { rem } from "polished";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { ReactComponent as CheckIconComponent } from "../../../assets/img/check-icon.svg";
import { ReactComponent as PlusIconComponent } from "../../../assets/img/icon-plus.svg";
import { percentDiff } from "../../../helpers/utils";
import StockStatus from "./stock-status";




const HiddenInput = styled.input`
	position: absolute;
	left: ${rem(14)};
	top: ${rem(20)};
	opacity: 0;
	width: 0;
	height: 0;
`;

const DisabledBox = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background: #ffffff;
	opacity: 0.7;
	border-radius: 5px;
	top: 0;
	left: 0;
`;

const FieldLabel = styled.label`
	position: relative;
	border: 1px solid #c9c9c9;
	border-radius: 5px;
	padding: ${rem(20)} ${rem(20)} ${rem(20)} ${rem(44)};
	position: relative;
	margin-top: ${rem(16)};
	width: 100%;
	display: block;
	cursor: pointer;

	${({ checked }) =>
		checked &&
		css`
			border: 1px solid #cc6f4c;
			box-shadow: 0px 0px 0px 2px #cc6f4c, 0px 6px 10px rgba(0, 0, 0, 0.05);
		`}
`;

const Title = styled.h5`
	font-style: normal;
	font-weight: 700;
	font-size: ${rem(15)};
	line-height: 1.33;
	font-family: Sans-serif;
	display: flex;
	max-width: 70%;
`;

const ImageContainer = styled.div`
	position: absolute;
	right: ${rem(8)};
	top: ${rem(8)};
	width: 30%;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	height: auto;
	z-index: -1;

	&::after {
		content: "";
		display: block;
		padding-top: 100%;
	}
`;

const SelectBox = styled.div`
	width: ${rem(20)};
	height: ${rem(20)};
	border: 1px solid #949494;
	box-sizing: border-box;
	border-radius: 4px;
	position: absolute;
	left: ${rem(14)};
	top: ${rem(20)};

	svg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) scale(0.5);
		opacity: 0;
		fill: white;
		transition: transform 0.3s, opacity 0.3s;
	}

	${({ checked }) =>
		checked &&
		css`
			background: #cc6f4c;
			border: 1px solid #cc6f4c;

			svg {
				opacity: 1;
				transform: translate(-50%, -50%) scale(1);
			}
		`}

	${({ type }) =>
		type === "radio" &&
		css`
			border-radius: 999em;
		`}
`;

const InfoList = styled.ul`
	margin-top: ${rem(7)};
	font-size: ${rem(13)};
	line-height: 1.5;
	color: #605d5c;
	font-family: sans-serif;

	li {
		padding-left: ${rem(17)};
		position: relative;

		svg {
			width: ${rem(9)};
			height: auto;
			left: 0;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
		}
	}
`;

const Pricing = styled.div`
	margin-top: ${rem(10)};
	color: #282a2c;
	margin-bottom: ${rem(10)};
	font-size: ${rem(13)};

	strong {
		font-weight: 700;
		font-size: ${rem(15)};
	}
`;

const Saving = styled.span`
	display: inline-block;
	font-weight: 700;
	color: #9e3f3a;
	font-size: ${rem(13)};
	padding-left: ${rem(10)};
	margin-left: ${rem(7)};
	position: relative;

	&::before {
		content: "";
		height: ${rem(12)};
		width: 1px;
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: ${rem(-6)};
		background: #9e3f3a;
	}
`;

const OldPrice = styled.span`
	color: #616161;
	position: relative;
	display: inline-block;

	&::after {
		content: "";
		position: absolute;
		left: -3px;
		right: -3px;
		top: 50%;
		height: 1px;
		background: #616161;
	}
`;

const NewPrice = styled.span`
	color: #9e3f3a;
`;

const Checkbox = ({
	id,
	name,
	label,
	description,
	price,
	listProps,
	variations,
	isChecked,
	isDisabled,
	onChange,
	highlight,
	image,
	tooltip,
	type = "radio",
	sideNotes,
	maxQuantity,
	isVariantDisabled,
	showStock,
	showSale,
	oldPrice
}) => {
	const [selectedVariant, setSelectedVariant] = useState(
		(variations && variations[0]) || null
	);

	const [selectedQuantity, setSelectedQuantity] = useState(1);

	const getPrice = () => {
		if (typeof price !== "number") {
			return selectedVariant.price;
		}

		if (maxQuantity) {
			return price * selectedQuantity;
		}

		return price;
	};

	const handleChange = (e) => {
		onChange(
			{
				id,
				label,
				...(selectedVariant ? { variant: selectedVariant.label } : {}),
				...(maxQuantity ? { quantity: selectedQuantity } : {}),
				price: getPrice(),
			},
			e.target.checked
		);
	};

	const fieldId = `${name}-${id}`;
	
	const discount = percentDiff(oldPrice, price);

	return (
		<React.Fragment>
			<FieldLabel checked={isChecked} htmlFor={fieldId}>
				<HiddenInput
					type={type}
					checked={isChecked}
					disabled={isDisabled}
					id={fieldId}
					onChange={handleChange}
				/>
				<SelectBox type={type} checked={isChecked}>
					<CheckIconComponent />
				</SelectBox>

				<Title>{label}</Title>

				{listProps && (
					<InfoList>
						{listProps.map((item, index) => (
							<li key={index}>
								{item.icon ? item.icon : <PlusIconComponent />}
								{item.text}
							</li>
						))}
					</InfoList>
				)}
				{showSale === true ? (
					<Pricing>
						SRP:{" "}
						<strong>
							<OldPrice>£{oldPrice}</OldPrice>
						</strong>
						<br />
						SALE:{" "}
						<strong>
							<NewPrice>£{price}</NewPrice>
						</strong>
						<Saving>Save {discount}%</Saving>
					</Pricing>
				) : (
					""
				)}
				{showStock === true ? (
					<StockStatus inStock={true} shippingInfo={"ships out in 1-3 days"} />
				) : (
					""
				)}

				<ImageContainer style={{ backgroundImage: `url(${image})` }} />
			</FieldLabel>
		</React.Fragment>
	);
};

export default Checkbox;
